import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'quipo-phn-number',
  templateUrl: './image-input.component.html',
  styleUrls: ['./image-input.component.scss'],
})
export class ImageInputComponent {
  @Input() isRequired: boolean;
  @Input() submitted: boolean;
  @Input() isDisable: boolean;
  @Input() icon: string;
  @Input() label: string;
  @Input() placeholder: string;
  @Input() value: string;
  @Output() valueChange = new EventEmitter();
  imageValue: string;
  inValid: boolean;

  change(newValue) {
  newValue = newValue.replace(/[a-zA-Z\s]+$/, '');
  newValue = newValue.replace(/(\d{4})(\d{3})(\d{3})/,'$1-$2-$3');
    this.valueChange.emit(newValue);
  }

  blockHyphenBackspace(event: KeyboardEvent) {
    if (event.key !== 'Backspace' && event.key !== 'Delete') return;

    const input = event.target as HTMLInputElement;
    const pos = input.selectionStart;

    if (pos === null) return;

    if (event.key === 'Backspace' && pos > 0 && input.value[pos - 1] === '-') {
      event.preventDefault();
    }

    if (
      event.key === 'Delete' &&
      pos < input.value.length &&
      input.value[pos] === '-'
    ) {
      event.preventDefault();
    }
  }

}
